import React from "react";

const SidenavItem = ({
  name,
  label,
  icon,
  iconStyle,
  activeSection,
  onClickItem
}) => (
  <button type="button"
    className={`btn sidenav-item d-flex w-100 align-items-center ` +
      (name == activeSection.name ? "active" : "")}
    onClick={() => onClickItem(name)}
      >
    <i className={icon} style={iconStyle}></i>
    <label class="w-100 text-truncate text-left ml-2">{label}</label>
  </button>

);

export default SidenavItem;
